import {AxiosInstance, AxiosResponse} from 'axios';
import { Cost } from './types';

export interface ICostsApi {
    getMany<T>(dateFrom: string, dateTo: string, employees: Array<number>): Promise<AxiosResponse<T>>;
    get<T>(id: number): Promise<AxiosResponse<T>>;
    create(data: FormData): Promise<AxiosResponse<Cost>>;
    update(id: number, data: FormData): Promise<AxiosResponse<Cost>>;
    delete<T extends {id: number}>(id: number): Promise<AxiosResponse<T>>;
}

export default class CostsApi implements ICostsApi {
    private readonly _axiosInstance: AxiosInstance;
    private readonly _controller: string = 'costs';
    private readonly _filePath: string = 'file';

    constructor(axiosInstance: AxiosInstance) {
        this._axiosInstance = axiosInstance;
    }

    async getMany<T>(dateFrom: string, dateTo: string, employees: number[]): Promise<AxiosResponse<T>> {
        const employeesSearch = employees.map((x) => `&employees=${x}`).join('');
        return await this._axiosInstance.get<T>(`${this._controller}?from=${dateFrom}&to=${dateTo}${employeesSearch}`);
    }
    async get<T>(id: number): Promise<AxiosResponse<T>> {
        return await this._axiosInstance.get<T>(`${this._controller}/${id}`);
    }

    async create(data: FormData): Promise<AxiosResponse<Cost>> {
        return await this._axiosInstance.post<Cost>(`${this._controller}`, data);
    }

    async update(id: number, data: FormData): Promise<AxiosResponse<Cost>> {
        return await this._axiosInstance.post<Cost>(`${this._controller}/${id}`, data);
    }

    async delete<T extends {id: number}>(id: number): Promise<AxiosResponse<T>> {
        return await this._axiosInstance.delete(`${this._controller}/${id}`);
    }
}